/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: 'us-east-1',
  aws_appsync_graphqlEndpoint: 'https://h6hjsphzvbatziuayxmxvvqcfi.appsync-api.us-east-1.amazonaws.com/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-5gf7pji2sne2desvncyzxyhjgm',
  aws_cognito_identity_pool_id: 'us-east-1:dba0b34b-b409-46a3-baa8-304bdf9239c6',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_CjmU2LJmC',
  aws_user_pools_web_client_id: 'kll5o8v63rfs2gf8kf1nifv35',
  oauth: {
    domain: 'auth.likiee.com',
    scope: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: 'https://www.likiee.com/',
    redirectSignOut: 'https://www.likiee.com/',
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_AND_IDENTITY_POOLS',
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE', 'APPLE'],
  aws_cognito_signup_attributes: ['NAME'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: ['REQUIRES_LOWERCASE', 'REQUIRES_NUMBERS', 'REQUIRES_SYMBOLS', 'REQUIRES_UPPERCASE'],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
  aws_user_files_s3_bucket: 'likiee-main163531-prod',
  aws_user_files_s3_bucket_region: 'us-east-1',
};

export default awsmobile;
